import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { mergeMap, Subject, takeUntil } from 'rxjs';
import { HeaderUserModel } from 'src/app/pathways-ui/models/header-user.model';
import { StudentProfile } from 'src/app/pathways-ui/models/student-profile.model';
import { LangService } from 'src/app/pathways-ui/services/lang.service';
import { AuthService } from 'src/app/services/auth.service';
import { StudentPortalService } from 'src/app/services/student-portal.service';

@Component({
    selector: 'student-portal-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnChanges {
    newNotifications = false;
    @Output()
    logout = new EventEmitter();
    @Output()
    login = new EventEmitter();
    @Input() signedInUser: HeaderUserModel;
    @Output()
    notificationsClickEvent = new EventEmitter();
    avatarUrl: string;
    hasAvatar: boolean = false;
    studentProfile: StudentProfile;
    destroyed = new Subject();

    constructor(
        public lang: LangService,
        private _adapter: DateAdapter<any>,
        private _authService: AuthService,
        private _studentPortalService: StudentPortalService,
        @Inject(MAT_DATE_LOCALE) private _locale: string
    ) {}

    async ngOnInit() {
        this._authService.isAuthenticated().then((userAuthenticated) => {
            if (userAuthenticated) {
                this.fetchStudentProfileAndAvatar();
            }
        });
    }

    ngOnChanges() {
        // changes.prop contains the old and the new value...
        this._authService.isAuthenticated().then((userAuthenticated) => {
            if (userAuthenticated) {
                this.fetchStudentProfileAndAvatar();
            }
        });
    }

    fetchStudentProfileAndAvatar() {
        this._studentPortalService
            .getStudentProfile()
            .pipe(
                takeUntil(this.destroyed),
                mergeMap((profile: StudentProfile) => {
                    this.studentProfile = profile;
                    return this._studentPortalService.getStudentAvatar();
                })
            )
            .subscribe(
                (avatar) => {
                    if (avatar) {
                        const url = URL.createObjectURL(avatar);
                        this.avatarUrl = url;
                        this.hasAvatar = true;
                    } else {
                        this.avatarUrl = '';
                        this.hasAvatar = false;
                    }
                },
                (err) => {
                    console.log(
                        'Error fetching student profile or avatar.',
                        err
                    );
                    this.avatarUrl = '';
                    this.hasAvatar = false;
                }
            );
    }

    setLang(lang: string) {
        this.lang.currentLang = lang;
        this._locale = lang;
        this._adapter.setLocale(this._locale);
    }

    onLogout() {
        this.logout.emit();
    }
    onLogin() {
        this.login.emit();
    }

    onHelpDeskClick() {
        window.open(
            'https://pathwaystoeducation.atlassian.net/servicedesk/customer/portals',
            '_blank'
        );
    }
    onNotificationClick() {
        this.notificationsClickEvent.emit();
    }
    ngOnDestroy(): void {
        this.destroyed.next(true);
        this.destroyed.complete();
    }
}
